import { render, staticRenderFns } from "./CreatePart2_2.vue?vue&type=template&id=feb20bf6&"
import script from "./CreatePart2_2.vue?vue&type=script&lang=js&"
export * from "./CreatePart2_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports